import { Reducer } from 'redux';
import { Machine } from "models/Machine";
import { IMachineActions, MachineActionType } from "redux/actions/settings/MachineActions";

const initialState: Machine[] | null = null;
export const machinesReducer: Reducer<Machine[] | null, IMachineActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case MachineActionType.FETCH_MACHINES_SUCCESS:
                {
                    return action.returnPayload as Machine[];
                }
            case MachineActionType.ADD_MACHINE_SUCCESS:
                {
                    let newMachines = [...state!];
                    newMachines.push({ ...action.returnPayload } as Machine)
                    return newMachines;
                }
            case MachineActionType.EDIT_MACHINE_SUCCESS:
            case MachineActionType.DELETE_MACHINE_SUCCESS:
                {
                    let newManufs = [...state!];
                    const updatedMachine = { ...action.returnPayload } as Machine;
                    newManufs = newManufs.map(nm => nm.id === updatedMachine.id ? updatedMachine : nm);
                    return newManufs;
                }
            default:
                return state;
        }
    };
